/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './product-info-panel.scss';
import AmountOfUseWithModal from '../amount-of-use-with-modal';
import LabeledString from '../labeled-string';
import MeasurementReading from '../../state/measurement-reading';
import Modal from '../../../../../sharedmodules/state/modal';
import Product from '../../state/product';
import PropTypes from 'prop-types';
import React from 'react';
import { buildDate } from '../../services/build-date';
import { buildNumber } from '../../services/build-number';

const ProductInfoPanel = (props) => (
    <section className="product-info-panel">
        <div className="product-info">
            <div className="row">
                <LabeledString
                    className="model"
                    data={props.product.model}
                    label="MODEL"
                />
                <LabeledString
                    className="days-rented"
                    data={buildNumber(props.product.daysRented)}
                    label="DAYS_ON_RENT"
                />
            </div>
            <div className="row">
                <LabeledString
                    className="base-machine"
                    data={props.product.baseMachineCode}
                    label="BASE_MACHINE"
                />
                <LabeledString
                    className="maintenance-plan"
                    data={props.product.maintenancePlan}
                    label="MAINTENANCE_PLAN"
                />
            </div>
            <div className="row">
                <LabeledString
                    className="build-date"
                    data={buildDate(props.product.buildDate)}
                    label="BUILT"
                />
                <AmountOfUseWithModal
                    isAmountOfUseModalOpen={props.isAmountOfUseModalOpen}
                    measurementReadings={props.measurementReadings}
                    onAmountOfUseModalClose={props.onAmountOfUseModalClose}
                    onAmountOfUseModalOpen={props.onAmountOfUseModalOpen}
                />
            </div>
            <div className="row">
                <LabeledString
                    className="delivery-date"
                    data={buildDate(props.product.deliveryDate)}
                    label="DELIVERED"
                />
                <LabeledString
                    className="product-status-label"
                    data={props.product.status[0].value}
                    label="STATUS"
                />
            </div>
        </div>
    </section>
);

ProductInfoPanel.displayName = 'ProductInfoPanel';
ProductInfoPanel.propTypes = {
    changeModalVisibility: PropTypes.func.isRequired,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onAmountOfUseModalClose: PropTypes.func.isRequired,
    onAmountOfUseModalOpen: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    productStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    updateStatus: PropTypes.func.isRequired,
};

export default ProductInfoPanel;
